/**
 * 搜索相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 统一搜索接口
 * 支持：
 * 1. 空关键词搜索（获取热门推荐）
 * 2. 关键词搜索（获取搜索建议和结果）
 * 3. 分页加载
 */
export async function search(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.RPCSearch, body, { params });
}
